import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Chip from "@mui/material/Chip";
import ButtonIpCopySnackbar from "../Components/ButtonIpCopySnackbar";
import MonthlyStatsPreview from "../Components/MonthlyStatsPreview";
import UserSubmissionsPreview from "../Components/UserSubmissionsPreview";
import PlayerWarpsPreview from "../Components/PlayerWarpsPreview";
import PlayerMarketsPreview from "../Components/PlayerMarketsPreview";
import StoreCalloutBanner from "../Components/StoreCalloutBanner";
import ScrollTop from "../Components/ScrollTop";
import PageSeo from "../Components/PageSeo";
import {
  DEFAULT_DESCRIPTION,
  DEFAULT_TITLE,
  HOME_IMAGE,
} from "../utils/siteSeo";

const SHOW_ADDITIONAL_GAME_MODES = false;

const survivalChips = [
  "Hard Survival",
  "1.21.11",
  "Permanent Claims",
  "SMP Friendly Sleep",
  "Searchable Player Market",
  "Player Mined Blocks",
  "Player Warps",
  "Fishing Competitions",
  "72H Death Chest",
  "Optional PvP",
  "Dragon Slaying",
  "Phantom Toggle",
  "Clan Homes and Claims",
  "Armour Stand Tools",
  "Big Doors",
  "Mini Blocks",
  "Image Imports",
  "Full Mob Spawns",
  "Mob Head Drops",
  "Large Render Distance",
  "Proximity Chat",
  "Minepacks",
  "Spawners",
  "Player and Server Stats",
  "Decorative Tags",
  "Chat Inventory Sharing",
  "Bedrock Support",
];
const extractionChips = [];

export default function Home() {
  return (
    <main>
      <PageSeo
        title={DEFAULT_TITLE}
        description={DEFAULT_DESCRIPTION}
        image={HOME_IMAGE}
        path="/"
      />
      {/* Hero unit */}
      <Box
        sx={{
          // bgcolor: "background.paper",
          backgroundImage: `url(${HOME_IMAGE})`,
          backgroundSize: "cover",
          pt: 14,
          pb: 6,
          paddingBottom: "80px",
        }}
      >
        <Container
          maxWidth="md"
          sx={{
            bgcolor: "#000",
            opacity: "80%",
            paddingTop: "20px",
            paddingBottom: "20px",
          }}
        >
          <Typography
            component="h1"
            variant="h3"
            align="center"
            color="white"
            gutterBottom
          >
            Survival Minecraft
            <br />
            No-Grief Community
          </Typography>
          <Typography variant="h5" align="center" color="white" paragraph>
            {/* Builder-Friendly
                <br />
                Player obtained blocks and markets.
                <br />
                Buy and Sell Player builds (Experimental) */}
            Casual survival for civil gamers.
          </Typography>
          <Typography variant="h6" align="center" color="white" paragraph>
            Guaranteed Hosting until 2028.
            <br />
            10+ Year Goal No-Reset SMP
            <br/>
            Free 150k Claim blocks.
          </Typography>
          <Stack
            sx={{ pt: 4 }}
            direction="row"
            spacing={2}
            justifyContent="center"
          >
            <ButtonIpCopySnackbar />
          </Stack>
        </Container>
      </Box>

      <Container sx={{ py: 8 }} maxWidth="lg">
        <Typography
          variant="overline"
          color="text.secondary"
          display="block"
        >
          Featuring
        </Typography>
        <Typography
          component="h3"
          variant="h3"
          color="text.primary"
          gutterBottom
        >
          &ldquo;26k Days&rdquo; Permanent Minecraft SMP
        </Typography>
        <Typography
          component="p"
          variant="h5"
          color="text.primary"
          gutterBottom
        >
          No-Reset Vanilla* Survival Sandbox World
        </Typography>
        <Typography variant="body1" color="text.primary" paragraph>
          Generous 150k+ claim blocks and many claim customizations included.
        </Typography>
        <Typography variant="body1" color="text.primary" paragraph>
          No custom enchants or skills for a pleasant vanilla gameplay experience.
        </Typography>
        <Typography variant="body1" color="text.primary" paragraph>
          Clean and Respectful Public Chat, local chat options and more.
        </Typography>

        <Typography
          component="h4"
          variant="h5"
          color="text.primary"
          gutterBottom
          sx={{ mt: 2 }}
        >
          Feature Sheet
        </Typography>

        <Grid container spacing={4}>
          {/* 26k Days Survival */}
          <Grid item key="survival-info" xs={12} sm={8} md={8}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
              variant="outlined"
            >
              {/* <CardMedia
                  component="div"
                  sx={{
                    // 16:9
                    pt: '56.25%',
                  }}
                  image={process.env.PUBLIC_URL + '/logo512.png'}
                /> */}
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography gutterBottom variant="h5" component="h2">
                  🌏 Long Term Survival - Permanent World (26k Days)
                </Typography>
                <Typography component="div">
                  <List>
                    <ListItem>
                      Started June 2023 - Pale Gardens Generated into existing
                      world!
                    </ListItem>
                    <ListItem>
                      Long term classic survival in a large open world. Play at
                      your own pace and terms.
                    </ListItem>
                    <ListItem>
                      All player mined blocks. Search the player markets to
                      boost your resources and save time.
                    </ListItem>
                    <ListItem>
                      No custom enchants or skills! Simply vanilla gameplay.
                    </ListItem>
                    <ListItem>
                      Free Rank upgrades as you play. Purchase Citizen with
                      $15,000 game cash.
                    </ListItem>
                  </List>
                </Typography>

                <Container sx={{ marginTop: "20px", paddingLeft: "5px" }}>
                  {survivalChips.map((chip) => (
                    <Chip
                      key={chip}
                      label={chip}
                      variant="outlined"
                      sx={{ margin: "3px" }}
                    />
                  ))}
                </Container>
              </CardContent>
            </Card>
          </Grid>

          <Grid item key="surival-features" xs={12} sm={4} md={4}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
              variant="outlined"
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography gutterBottom variant="h5" component="h2">
                  Features
                </Typography>
                <List>
                  <ListItem>Large world with permanent claims</ListItem>
                  <ListItem>Free 250k+ Claim Blocks</ListItem>
                  <ListItem>20 TPS most of the time</ListItem>
                  <ListItem>Vanilla Spawn rates</ListItem>
                  <ListItem>Builder Friendly, No Grief!</ListItem>
                  <ListItem>Fisher Friendly</ListItem>
                  <ListItem>Real Estate Options</ListItem>
                  <ListItem>Extended View Distance</ListItem>
                  <ListItem>Clean and Respecful Chat</ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <StoreCalloutBanner
          href="https://store.mcverse.city"
          headline="Made possible by our Supporters. Purchase a rank to extend our guaranteed hosting."
          subline="Premium perks are available as part of the Free Citizen Rank"
          sx={{ mt: 4 }}
        />

        <Box sx={{ pt: 5 }}>
          <PlayerMarketsPreview />
        </Box>

        {SHOW_ADDITIONAL_GAME_MODES ? (
          <>
        <Typography
          component="h4"
          variant="h4"
          color="text.primary"
          gutterBottom
          paddingTop={5}
          paddingBottom={2}
        >
          Additional Community Game Modes
        </Typography>

        <Grid container spacing={4}>
          <Grid item key="hardcore-info" xs={12} sm={12} md={12}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
              variant="outlined"
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography gutterBottom variant="h5" component="h2">
                  ⏳ Hardcore+ "Generations"
                </Typography>
                <Typography component="div">
                  <List>
                    <ListItem>
                      No Grief Hardcore Vanilla Minecraft. "Death is permanent."
                      philosophy encouraged.
                    </ListItem>
                    <ListItem>
                      Each New Life (respawn) all stats, inventory,
                      acheivements, pets, etc are wiped.
                    </ListItem>
                    <ListItem>
                      <strong>
                        Launched July 2025. Mostly a complete experiment that is
                        still available to explore
                      </strong>
                    </ListItem>
                    <ListItem>
                      Will be reset and re-imagined in Fall 2026.
                    </ListItem>
                  </List>
                </Typography>
                <br />
                <Typography gutterBottom variant="h6" component="h6">
                  Features
                </Typography>
                <List>
                  <ListItem>Limited respawns within a generation.</ListItem>
                  <ListItem>
                    When a generation steps foward, a free respawn is available.
                  </ListItem>
                  <ListItem>
                    Each generation has varied rules on player sleep percentage,
                    generation length, respawn cooldowns, respawn limits, etc.
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>
          <Grid item key="vanilla-info" xs={12} sm={6} md={6}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
              variant="outlined"
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography gutterBottom variant="h5" component="h2">
                  🌱 Vanilla Survival
                </Typography>
                <Typography component="div">
                  <List>
                    <ListItem>
                      A pure vanilla survival with Protection Stones. <br />
                      <br />
                      World resets will follow Minecraft Releases, so you can
                      test the newest version ASAP!
                    </ListItem>
                  </List>
                </Typography>
                <br />
                <Typography gutterBottom variant="h6" component="h6">
                  Features
                </Typography>
                <List>
                  <ListItem>Try the latest minecraft version!</ListItem>
                  <ListItem>1000 block Spawn Radius</ListItem>
                  <ListItem>~50% Sleep</ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>
          <Grid item key="plots-info" xs={12} sm={6} md={6}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
              variant="outlined"
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography gutterBottom variant="h5" component="h2">
                  🚧 Creative Plots - Design and Testing
                </Typography>
                <Typography component="div">
                  <List>
                    <ListItem>
                      A plots world for you to test your ideas.
                    </ListItem>
                    <ListItem>
                      Work in progress. If you have a use case you'd like to
                      try, ask!
                    </ListItem>
                  </List>
                </Typography>
                <br />
                <Typography gutterBottom variant="h6" component="h6">
                  Features
                </Typography>
                <List>
                  <ListItem>Litematica Pasting (By Request)</ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
          </>
        ) : (
          <Box sx={{ pt: 5 }}>
            <PlayerWarpsPreview />
          </Box>
        )}
      </Container>

      <Container sx={{ py: 2 }} maxWidth="lg">
        <MonthlyStatsPreview />
      </Container>

      <Container sx={{ py: 2 }} maxWidth="lg">
        <UserSubmissionsPreview />
      </Container>

      {/* Scroll to Top Button */}
      <ScrollTop bottomOffset={88} />
    </main>
  );
}
